import { createIcon } from '@chakra-ui/react';

export const Twitter = createIcon({
  displayName: 'Twitter',
  viewBox: '0 0 375 374.9999',
  path: (
    <>
      <defs>
        <path
          d="M 7.09375 7.09375 L 367.84375 7.09375 L 367.84375 367.84375 L 7.09375 367.84375 Z M 7.09375 7.09375 "
          fill="#000000"
        />
      </defs>
      <g>
        <path
          d="M 187.46875 7.09375 C 87.851562 7.09375 7.09375 87.851562 7.09375 187.46875 C 7.09375 287.085938 87.851562 367.84375 187.46875 367.84375 C 287.085938 367.84375 367.84375 287.085938 367.84375 187.46875 C 367.84375 87.851562 287.085938 7.09375 187.46875 7.09375 "
          fillOpacity="1"
          fillRule="nonzero"
          fill="#000000"
        />
      </g>
      <g transform="translate(85, 75)">
        {' '}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          version="1.1"
          height="215"
          width="215"
        >
          <path
            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            fill="#ffffff"
          />
        </svg>{' '}
      </g>
    </>
  ),
});
